/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from "react";
import RangeSlider from "../../../../../common/components/RangeSlider";
import InsightBox from "../InsightBox";

const FilterRangeSlider = (props) => {
    const {
        ftOption,
        stateObj,
        handleSubmitFilter,
    } = props

    if (!ftOption) return null;

    const { id, label, step = 1, insight, infoText } = ftOption;

    const min = Number.isFinite(ftOption.min) ? ftOption.min : 0;
    const max = Number.isFinite(ftOption.max) ? ftOption.max : 100;

    // The slice stores the full filter object at stateObj[id] after submit.
    // Unwrap to get the actual {min, max} value the slider expects.
    const rawValue = stateObj?.[id];
    const currentValue = (rawValue && typeof rawValue === 'object' && 'value' in rawValue)
        ? rawValue.value ?? { min, max }
        : (rawValue ?? { min, max });

    const handleChange = (value) => {
        handleSubmitFilter({
            ...ftOption,
            value: value
        });
    };

    return (
        <div>
            <RangeSlider
                id={id}
                name={label}
                min={min}
                max={max}
                step={step}
                value={currentValue}
                onChangeComplete={handleChange}
                infoText={infoText}
            />
            {insight && (
                <div style={{ marginTop: '8px' }}>
                    <InsightBox
                        text={insight.text}
                        title={insight.title}
                    />
                </div>
            )}
        </div>
    );
};

export default FilterRangeSlider;